module.exports = __webpack_public_path__ + "img/Commercial Complex - Gadhinglaj-min.8f564245.jpg";